import styled from 'styled-components';
import {GAME_BOX} from '../../../css-constants';

//.hover-details
export const GameButtonsDefaultBox = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    z-index: 2;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    transform: translateY(5rem);
    opacity: 0;
    transition: all 0.3s ease-in-out;

    .${GAME_BOX}:hover & {
            transform: translateY(0);
            opacity: 0.9;
    }
`;